module.exports = __webpack_public_path__ + "19c1fad65f11922d4e255c27d8952842.svg";